export default (taxes = [], amount = 0) => {
  if (!Array.isArray(taxes)) {
    return { ledgerAmount: amount, taxTotalAmount: 0 }
  }

  if (taxes.length == 0) {
    return { ledgerAmount: amount, taxTotalAmount: 0 }
  }

  const taxTotalAmt = Object.values(taxes).reduce(
    (taxTotalAmt, tax) => parseFloat(taxTotalAmt) + parseFloat(tax.tax_amount),
    0,
  )

  const ledgerAmount =
    taxTotalAmt > 0
      ? Math.abs(parseFloat(amount)) + taxTotalAmt
      : parseFloat(amount) + taxTotalAmt

  return { ledgerAmount: ledgerAmount, taxTotalAmount: taxTotalAmt }
}
